<template>
  <a-modal
    :title="title"
    width="40%"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    :keyboard="false"
    @cancel="handleCancel"
    @ok="submit"
    ok-text="保存"
    cancel-text="取消"
    :destroyOnClose="true"
  >
    <div>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="名称" prop="buildName">
          <a-select v-model="form.buildName" @change="changeText">
            <a-select-option :value="item.text" v-for="item in jblist">{{
              item.title
            }}</a-select-option>
          </a-select>
          <template v-if="form.buildName == '其他'">
            <a-input v-model="form.otherType" />
          </template>
        </a-form-model-item>
        <a-form-model-item label="大赛名称" v-if="isbsshow" prop="title">
          <a-input v-model="form.title" @blur="changedate" />
        </a-form-model-item>
        <a-form-model-item label="年份" prop="acquireYear">
          <a-date-picker
            placeholder="请选择年份"
            v-model="form.acquireYear"
            :open="yearShowOne"
            :locale="locale"
            :format="'YYYY'"
            mode="year"
            @openChange="openChangeOne"
            @panelChange="panelChangeOne"
            @change="handleClearAcquireYear"
          />
        </a-form-model-item>
        <a-form-model-item label="数量" v-if="!isbsshow" prop="amount">
          <a-input-number
            v-model="form.amount"
            min="1"
            precision="0"
            @blur="blurValue"
          />
        </a-form-model-item>
        <a-form-model-item
          label="参赛/指导教师姓名"
          v-if="isbsshow"
          prop="teacherName"
        >
          <a-input v-model="form.teacherName" @blur="changedate" />
        </a-form-model-item>
        <a-form-model-item label="级别" v-if="isbsshow" prop="levelType">
          <div class="flex">
            <a-select v-model="form.levelType" @change="changedate">
              <a-select-option
                :value="item.text"
                v-for="item in xwlist"
                :key="item.text"
                >{{ item.title }}</a-select-option
              >
              <!-- <a-select-option value="其他" >{{
                item.title
              }}</a-select-option> -->
            </a-select>
            <template v-if="form.levelType == '其他'">
              <a-input v-model="form.otherLevelType" class="ipt-other" />
            </template>
          </div>
        </a-form-model-item>
        <!-- <a-form-model-item label="类别"  v-if="isbsshow" prop="levelType">
          <a-select v-model="form.levelType">
            <a-select-option :value="item.text" v-for="item in xwlist">{{
              item.title
            }}</a-select-option>
          </a-select>
          <template v-if="form.levelType == '其他'">
            <a-input v-model="form.otherLevelType" class="ipt-other" />
          </template>
        </a-form-model-item> -->
        <a-form-model-item label="奖项" v-if="isbsshow" prop="award">
          <a-input v-model="form.award" @blur="changedate" />
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
</template>
    
  <script>
import { getAction, postAction, putAction } from "@/api/index";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import BaseEditor from "@/components/common/BaseEditor.vue";
moment.locale("zh-cn");
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      other: "",
      form: {
        amount: "",
        buildName: "",
        acquireYear: "",
        levelType: "",
        otherLevelType: "",
        title: "",
        award: "",
      },
      rules: {
        // buildName: [
        //   {
        //     required: true,
        //     message: "请输入名称",
        //     trigger: "blur",
        //   },
        // ],
        // acquireYear: [
        //   {
        //     validator: (rule, value, callback) => {
        //       if (this.form.acquireYear!='') {
        //         callback(); // 验证通过
        //       } else {
        //         callback(new Error('请选择年份'));
        //       }
        //     },
        //     required: true,
        //     message: "请选择年份",
        //     //          type: 'string',
        //     trigger: "change",
        //   },
        // ],
        // amount: [
        //   {
        //     required: true,
        //     message: "请输入数量",
        //     trigger: "blur",
        //   },
        // ],
      },
      rules1: {
        buildName: [
          {
            validator: (rule, value, callback) => {
              if (this.form.buildName != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择名称"));
              }
            },
            required: true,
            message: "请选择名称",
            trigger: "blur",
          },
        ],
        acquireYear: [
          {
            validator: (rule, value, callback) => {
              if (this.form.acquireYear != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择年份"));
              }
            },
            required: true,
            message: "请选择年份",
            //          type: 'string',
            trigger: "change",
          },
        ],
        amount: [
          {
            validator: (rule, value, callback) => {
              if (this.form.amount != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请输入数量"));
              }
            },
            required: true,
            message: "请输入数量",
            trigger: "blur",
          },
        ],
      },
      rules2: {
        buildName: [
          {
            validator: (rule, value, callback) => {
              if (this.form.buildName != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择名称"));
              }
            },
            required: true,
            message: "请选择名称",
            trigger: "blur",
          },
        ],
        title: [
          {
            validator: (rule, value, callback) => {
              if (this.form.title != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请输入大赛名称"));
              }
            },
            required: true,
            message: "请输入大赛名称",
            trigger: "blur",
          },
        ],
        acquireYear: [
          {
            validator: (rule, value, callback) => {
              if (this.form.acquireYear != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择年份"));
              }
            },
            required: true,
            message: "请选择年份",
            //          type: 'string',
            trigger: "change",
          },
        ],
        teacherName: [
          {
            validator: (rule, value, callback) => {
              if (this.form.teacherName != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请输入参赛/指导教师姓名"));
              }
            },
            required: true,
            message: "请输入参赛/指导教师姓名",
            trigger: "blur",
          },
        ],
        levelType: [
          {
            validator: (rule, value, callback) => {
              if (this.form.levelType != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择级别"));
              }
            },
            required: true,
            message: "请选择级别",
            trigger: "change",
          },
        ],
        award: [
          {
            validator: (rule, value, callback) => {
              if (this.form.award != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请输入奖项"));
              }
            },
            required: true,
            message: "请输入奖项",
            trigger: "blur",
          },
        ],
      },
      yearShowOne: false,
      zh_CN,
      locale,
      applyType: 1,
      // 添加还是编辑
      type: "",
      // 弹框标题
      title: "",
      xwlist: [],
      jblist: [],
      kclist: [],
      ishow: false,
      ifirst: true,
      isbsshow: false,
    };
  },
  components: { BaseEditor },
  mounted() {},
  methods: {
    changeText() {
      let buildName = this.form.buildName;

      if (
        (buildName.indexOf("大赛") != -1 ||
          buildName.indexOf("比赛") != -1 ||
          buildName.indexOf("竞赛") != -1 ||
          buildName.indexOf("赛事") != -1) &&
        buildName.indexOf("青年教师教学基本功比赛") == "-1"
      ) {
        this.isbsshow = true;
        this.rules = this.rules2;
      } else {
        this.isbsshow = false;
        this.rules = this.rules1;
        // this.form.title = "";
        // this.form.levelType = "";
        //  this.form.otherType='';
        // this.form.otherLevelType = "";
        // this.form.award = "";
        // this.form.teacherName = "";
      }
      this.$forceUpdate();
      // this.$refs.ruleForm.resetFields() // 重置字段值并清除校验
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.clearValidate(); // 确保校验状态清除
      }
    },
    changedate() {
      this.$forceUpdate();
    },
    openChangeOne(status) {
      if (status) {
        this.yearShowOne = true;
      }
    },
    handleClearAcquireYear(val) {
      this.form.acquireYear = ""; // 或者适当的空值，根据你的业务需求
      this.$forceUpdate();
    },
    panelChangeOne(value) {
      this.form.acquireYear = value;
      this.$refs.ruleForm.clearValidate("acquireYear");
      this.yearShowOne = false;
    },
    init(type, record) {
      this.type = type;
      this.visible = true;
      this.getxwlist();
      this.getcgjb();
      if (type == "add") {
        this.form = {};
        this.form.amount = "";
        this.form.buildName = "";
        this.form.acquireYear = "";
        this.form.levelType = "";
        this.form.otherLevelType = "";
        this.form.title = "";
        this.form.award = "";
        this.isbsshow = false;
        this.rules = this.rules1;
        // this.form.applyId = record.id;
        this.title = "新增团队建设";
        this.form.acquireYear = new Date().getFullYear() + "";
      } else {
        this.title = "编辑团队建设";
        this.form = {
          buildName: record.buildName,
          // achievementType: record.achievementType,
          amount: record.amount,
          levelType: record.levelType,
          // courseType: record.courseType,
          // applyId: record.applyId,
          acquireYear: record.acquireYear,
          id: record.id,
          otherType: record.otherType,
          title: record.title,
          award: record.award,
          otherLevelType: record.otherLevelType,
          teacherName: record.teacherName,
          // content: record.content,
        };
        this.changeText();
      }
    },
    handleCancel() {
      this.visible = false;
    },
    getxwlist() {
      getAction("/baseCommon/getDictItemsByCode?code=achievement_level").then(
        (res) => {
          if (res.code == 200) {
            this.xwlist = res.result;
          }
        }
      );
    },
    getcgjb() {
      getAction("/baseCommon/getDictItemsByCode?code=build_name").then(
        (res) => {
          if (res.code == 200) {
            this.jblist = res.result;
          }
        }
      );
    },
    submit() {
      if (
        typeof this.form.acquireYear == "object" &&
        this.form.acquireYear != ""
      ) {
        this.form.acquireYear =
          new Date(this.form.acquireYear).getFullYear() + "";
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.type == "add") {
            if (this.$parent.oldInfos?.id) {
              let params = this.form;
              params.applyType = this.applyType;
              params.applyId = this.$parent.oldInfos?.id;
              postAction("/lx/lxTeamBuilding/add", params).then((res) => {
                if (res.code == 200) {
                  this.visible = false;
                  this.$message.success("添加成功");
                  this.$emit("addGain", {});
                } else {
                  this.$message.error(res.message);
                }
              });
            } else {
              let params = this.form;
              this.visible = false;
              this.$message.success("添加成功");
              this.$emit("addGain", { record: params, type: "add" });
            }
          } else {
            let params = this.form;
            if (typeof this.form.acquireYear == "object") {
              params.acquireYear =
                new Date(this.form.acquireYear).getFullYear() + "";
            }
            if (this.$parent.oldInfos?.id) {
              params.applyId = this.$parent.oldInfos?.id;
              putAction("/lx/lxTeamBuilding/edit", params).then((res) => {
                if (res.code == 200) {
                  this.visible = false;
                  this.$message.success("编辑成功");
                  this.$emit("addGain", {});
                } else {
                  this.$message.error(res.message);
                }
              });
            } else {
              this.visible = false;
              this.$message.success("编辑成功");
              this.$emit("addGain", { record: params, type: "edit" });
            }
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    openChangeOne(status) {
      if (status) {
        this.yearShowOne = true;
      }
    },
    panelChangeOne(value) {
      const year = moment(value).format("YYYY");
      this.form.acquireYear = year + "";
      this.yearShowOne = false;
      this.$refs.ruleForm.clearValidate("acquireYear");
    },
  },
};
</script>
  
  <style lang="scss" scoped>
/deep/ .ant-modal-title {
  text-align: center;
}
/deep/ .ant-input-number-handler-wrap {
  display: none;
}
</style>
  